import styled, { css } from 'styled-components';

import Button from 'components/Buttons/Button';

export const Card: any = styled.div`
  margin: 8px 16px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 6px 10px 0 rgba(51, 41, 39, 0.16);
  background: ${({ theme }) => theme.cardFlight.background};
  min-width: 250px;
  cursor: pointer;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 8px 0;
  }
`;
Card.Wrapper = styled.div``;

export const Tags = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  flex: 1;
  margin-left: 10px;
`;

const tag = css`
  display: flex;
  align-items: center;
  font-size: 10px;
  border-radius: 16px;
  padding: 2px 11px 2px 14px;
  margin-bottom: 2.5px;
  width: fit-content;

  &:last-child {
    margin-top: 0;
  }

  &::after {
    content: '';
    height: 12px;
    width: 12px;
    margin-left: 7px;
    display: block;
    background-size: cover;
    background-position: center;
    flex-grow: 0;
    flex-shrink: 0;
  }
`;

export const LimitExceededTag = styled.span`
  ${tag}
  color: ${({ theme }) => theme.cardFlight.exceededColor};
  background-color: ${({ theme }) => theme.cardFlight.costExceededBackground};

  &::after {
    background-image: url('/images/exceeded-icon.svg');
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
  overflow: hidden;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 16px;
`;

export const PriceContainer = styled.div``;

export const Price = styled.h5`
  margin-left: 4px;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.83px;
  text-align: right;
  color: #332927;
`;

export const Currency = styled.span`
  margin: 8px 0 4px 2px;
  font-size: 10px;
  font-weight: 400;
  line-height: 1.33;
  text-align: right;
  color: #332927;
`;

export const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const FinalPrice = styled.span`
  font-size: 12px;
  line-height: 14px;
  font-weight: normal;
  color: #939da3;
`;

export const Summary = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0 0;
  border-top: 0.5px solid #e5e5e4;
  width: 100%;
`;

export const ConfirmButtonBase = styled(Button)`
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  border-width: 0;
  border-radius: 8px;
`;

export const ConfirmButton = styled(ConfirmButtonBase)`
  width: 130px;
  height: 36px;
`;

export const FinalPriceWithTaxesMobile = styled.span`
  color: #8c8b8b;
  font-size: 12px;
  line-height: 1.2em;
  text-align: left;
`;

export const BreakRulesMessage = styled.span`
  font-size: 12px;
  line-height: 1.2em;
  text-align: left;
  color: #ff441f;
  margin-top: 4px;
`;

export const NoBreakRulesMessage = styled.span`
  font-size: 12px;
  line-height: 1.2em;
  text-align: left;
  color: #13b84e;
  margin-top: 4px;
`;
